<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        @click="open('add')"
      >添加</el-button>
      <el-button
        type="success"
        size="mini"
        
        @click="getList"
        >刷新</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      >
        <el-button
          slot="reference"
          type="danger"
          size="mini"
          style="margin-left: 10px"
          @click="openDelete"
        >删除</el-button>
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px;">编号</label>
        <el-input
          v-model="sn"
          placeholder="请输入编号"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">语种</label>
        <el-input
          v-model="lang"
          placeholder="请输入语种"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1031px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
     <el-table-column type="selection" width="50" />
     <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isSystem">-</div>
          <el-button
            v-else
            type="primary"
            class="edit-button"
            size="mini"
            
            @click="edit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column> 
      <el-table-column prop="sn" label="编号" width="160" />
      <el-table-column prop="lang" label="语种" width="150" />
      <el-table-column prop="withdrawSum" label="图片" width="100">
        <template slot-scope="scoped">
          <el-image
            style="width: 60px;"
            :src="scoped.row.image"
            fit="fill"
            :preview-src-list="new Array(scoped.row.image)"
            @click.stop="handleClickItem"
          />
        </template>
      </el-table-column>
      <el-table-column prop="toPath" label="点击跳转链接" width="200" />

      <el-table-column prop="orders" label="排序" width="100" />
      <el-table-column prop="createDate" label="创建时间" width="170" />
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="600px"
      title="添加"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
     <!-- 表单 -->
     <el-form ref="form" :model="active" label-width="150px" size="mini">
        <el-form-item label="英文">
            <UploadImage ref="imageEn" @upLoadImage='upLoadImage1'></UploadImage>
        </el-form-item>
        <el-form-item label="西班牙语">
            <UploadImage ref="imageEs" @upLoadImage='upLoadImage2'></UploadImage>
        </el-form-item>
        <el-form-item label="法语">
            <UploadImage ref="imageFr" @upLoadImage='upLoadImage3'></UploadImage>
        </el-form-item>
        <el-form-item label="德语">
            <UploadImage ref="imageDe" @upLoadImage='upLoadImage4'></UploadImage>
        </el-form-item>
        <el-form-item label="葡萄牙语">
            <UploadImage ref="imagePt" @upLoadImage='upLoadImage5'></UploadImage>
        </el-form-item>
        <el-form-item label="土耳其语">
            <UploadImage ref="imageTr" @upLoadImage='upLoadImage6'></UploadImage>
        </el-form-item>
        <el-form-item label="希腊语">
            <UploadImage ref="imageGr" @upLoadImage='upLoadImage7'></UploadImage>
        </el-form-item>
        <el-form-item label="阿拉伯语">
            <UploadImage ref="imageEg" @upLoadImage='upLoadImage8'></UploadImage>
        </el-form-item>
        <el-form-item label="意大利语">
            <UploadImage ref="imageIt" @upLoadImage='upLoadImage9'></UploadImage>
        </el-form-item>
        <el-form-item label="波斯语">
            <UploadImage ref="imageIr" @upLoadImage='upLoadImage10'></UploadImage>
        </el-form-item>
        <el-form-item label="荷兰语">
            <UploadImage ref="imageNl" @upLoadImage='upLoadImage11'></UploadImage>
        </el-form-item>
        <el-form-item label="印地语">
            <UploadImage ref="imageIn" @upLoadImage='upLoadImage12'></UploadImage>
        </el-form-item>
        <el-form-item label="乌兹别克语">
            <UploadImage ref="imageUz" @upLoadImage='upLoadImage13'></UploadImage>
        </el-form-item>
        <el-form-item label="越南语">
            <UploadImage ref="imageVn" @upLoadImage='upLoadImage14'></UploadImage>
        </el-form-item>
        <el-form-item label="韩语">
            <UploadImage ref="imageKo" @upLoadImage='upLoadImage15'></UploadImage>
        </el-form-item>
        <el-form-item label="印尼语">
            <UploadImage ref="imageId" @upLoadImage='upLoadImage16'></UploadImage>
        </el-form-item>
         <el-form-item label="俄语">
            <UploadImage ref="imageRu" @upLoadImage='upLoadImage17'></UploadImage>
        </el-form-item>
        <el-form-item label="波兰语">
            <UploadImage ref="imagePl" @upLoadImage='upLoadImage18'></UploadImage>
        </el-form-item>
        <el-form-item label="匈牙利语">
            <UploadImage ref="imageHu" @upLoadImage='upLoadImage19'></UploadImage>
        </el-form-item>
        <el-form-item label="罗马尼亚语">
            <UploadImage ref="imageRo" @upLoadImage='upLoadImage20'></UploadImage>
        </el-form-item>
        <el-form-item label="点击跳转链接">
          <div>
             <div><el-input v-model="active.toPath" placeholder="请输入链接"/> 留空表示不跳转</div>
             <div>例如：交易导航页/pages/recharge/index</div>
          </div>
          
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="active.orders" placeholder="排序"/>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="bannerSave()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >添加</el-button>
        </el-popconfirm>
        </el-form-item>

      </el-form>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :visible.sync="dialogVisibleUpdate"
      width="600px"
      title="添加"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
     <!-- 表单 -->
     <el-form ref="form" :model="editForm" label-width="150px" size="mini">
        <el-form-item label="英文">
            <UploadImage ref="editFormImage" @upLoadImage='editFormImage'></UploadImage>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="editForm.orders" placeholder="排序"/>
        </el-form-item>
        <el-form-item label="点击跳转链接">
          <div>
            <div> <el-input v-model="editForm.toPath" placeholder="请输入链接"/> 留空表示不跳转</div>
             <div>例如：交易导航页/pages/recharge/index</div>
          </div>
          
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定更新？" @confirm="bannerUpdate()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >更新</el-button>
        </el-popconfirm>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module

import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination,VueUeditorWrap,UploadImage },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {},
      // 修改表单
      editForm: { },
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      yiFangDetailList: [], // 
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      buttongLoding: false, // 按钮加载
      sn:'',
      lang:'en',
      isEnabled:false,
      isChat:false,
      isTelegram:false,
      isWhatsApp:false,
      isMessenger:false,
      isLinkUrl:false,
      isTelegramGroup:false,
      dialogVisibleUpdate:false,
      dataTime:['',''],
      yifangId:''
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    upLoadImage1(img){
        this.active.imageEn = img
    },
    upLoadImage2(img){
        this.active.imageEs = img
    },
    upLoadImage3(img){
        this.active.imageFr = img
    },
    upLoadImage4(img){
        this.active.imageDe = img
    },
    upLoadImage5(img){
        this.active.imagePt = img
    },
    upLoadImage6(img){
        this.active.imageTr = img
    },
    upLoadImage7(img){
        this.active.imageGr = img
    },
    upLoadImage8(img){
        this.active.imageEg = img
    },
    upLoadImage9(img){
        this.active.imageIt = img
    },
    upLoadImage10(img){
        this.active.imageIr = img
    },
    upLoadImage11(img){
        this.active.imageNl = img
    },
    upLoadImage12(img){
        this.active.imageIn = img
    },
    upLoadImage13(img){
        this.active.imageUz = img
    },
    upLoadImage14(img){
        this.active.imageVn = img
    },
    upLoadImage15(img){
        this.active.imageKo = img
    },
    upLoadImage16(img){
        this.active.imageId = img
    },
    upLoadImage17(img){
        this.active.imageRu = img
    },
    upLoadImage18(img){
        this.active.imagePl = img
    },
    upLoadImage19(img){
        this.active.imageHu = img
    },
    upLoadImage20(img){
        this.active.imageRo = img
    },
    editFormImage(img){
        this.editForm.image = img
    },
    
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        sn:this.sn,
        lang:this.lang
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
        this.$api.operate
        .bannerList(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
     // 编辑
    edit(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogVisibleUpdate = true;
      this.$nextTick(() => {
        this.$refs.editFormImage.init(this.editForm.image);
      });
    },
    bannerUpdate() {
      let editForm = {
        id: this.editForm.id,
        image: this.editForm.image,
        orders: this.editForm.orders,
        toPath: this.editForm.toPath
      }
      this.$api.operate
        .bannerUpdate(editForm)
        .then((res) => {
          this.$message.success(res);
          this.editDialogVisible = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭添加弹窗
    handleClose() {
      this.$refs.active.resetFields();
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .bannerDelete(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    // 打开添加弹窗
    open() {
      this.dialogVisible = true;
      this.active = {}
      this.$nextTick(() => {
        this.$refs.imageEn.init('');
        this.$refs.imageEs.init('');
        this.$refs.imageFr.init('');
        this.$refs.imageDe.init('');
        this.$refs.imagePt.init('');
        this.$refs.imageTr.init('');
        this.$refs.imageGr.init('');
        this.$refs.imageEg.init('');
        this.$refs.imageIt.init('');
        this.$refs.imageIr.init('');
        this.$refs.imageNl.init('');
        this.$refs.imageIn.init('');
        this.$refs.imageUz.init('');
        this.$refs.imageVn.init('');
        this.$refs.imageKo.init('');
        this.$refs.imageId.init('');
        this.$refs.imageRu.init('');
        this.$refs.imagePl.init('');
        this.$refs.imageHu.init('');
        this.$refs.imageRo.init('');
      });
    },
    happenTimeFun(num){
	let date = new Date(num);
	//时间戳为10位需*1000，时间戳为13位的话不需乘1000
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM; //月补0
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d; //天补0
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h; //小时补0
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m; //分钟补0
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s; //秒补0
	return y + '-' + MM + '-' + d
},
    // 添加用户
    bannerSave() {
          this.$api.operate
            .bannerSave(this.active)
            .then((res) => {
              this.$message.success(res);
              this.dialogVisible = false;
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
    },
    // 打开删除弹窗
    openDelete() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {
          
        });
    },
   
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
</style>
